// store/pieces/piecesInitialState.ts
import { TypeMenu } from '../../enums/piecesEnums';
import { DetailedPiece, EcritureHistory, Piece, PiecesQueryParams } from '../../types';

/**
 * @french
 * État initial du slice des pièces comptables.
 */
export const piecesInitialState = {
  isPiecesLoading: false,
  isListPieceEmpty: false,
  queryParams: null as PiecesQueryParams | null,
  detailedPiece: undefined as DetailedPiece | undefined,
  isEcritureLoading: false,
  ecritureHistory: [] as EcritureHistory[],
  isChangeJournalActive: false,
  typeMenu: TypeMenu.SAVE_AND_CLOSE as TypeMenu,
  pieceIndex: 0,
  piece: undefined as Piece | undefined,
  preview: {
    visible: 'hidden' as PreviewModalVisibility,
    previewUrl: null as string | null,
    previewFileName: undefined as string | undefined,
    csvData: [] as string[][],
    isCsvFile: false,
    fileContent: null as string | null,
  },
};

/**
 * @french
 * Type dérivé de l’état initial.
 */
export type PiecesState = typeof piecesInitialState;

export type PreviewModalVisibility =
  | 'visible-powens-transactions'
  | 'visible-pieces'
  | 'visible-grand-livre'
  | 'visible-journal'
  | 'hidden';
